export const ERRORMESSAGES = {
    UNAUTHORIZED: 'ERROR.HTTP_UNAUTHORIZED',
    INTERNALSERVER: 'ERROR.HTTP_INTERNALSERVER',
    APPLICATIONERROR: 'ERROR.APPLICATION_DEFAULT'
}